export default __webpack_public_path__ + "static/media/drone.ba373ff3.mp4";